export default function(category_id) {
  let map = {
    "1": "apv",
    "2": "bestemmingsplan",
    "3": "evenementen",
    "4": "horeca",
    "6": "omgeving",
    "7": "verkeer",
    "8": "verkoop",
    "9": "water",
    "10": "berichtgeving"
  };

  return map[category_id];
}
